import React from 'react';
import { Sidebar } from './Sidebar';
export function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex h-screen bg-slate-50 overflow-hidden font-sans" data-id="element-11">
      <Sidebar data-id="element-12" />

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-13">
        <main className="flex-1 overflow-y-auto p-8" data-id="element-14">{children}</main>
      </div>
    </div>;
}